export enum LabelsLayout {
  OK = 0,
  TooFar = 1,
  TooClose = 2
}
